import _ from 'lodash';
import {toNumber} from "./toNumber";
import {getCurrencyRate} from "./getCurrencyRate";

export const getCurrencyPrice = price => {
    const rate = getCurrencyRate();

    if (rate === 1) {
        return price;
    }

    return _.toString((toNumber(price) * rate).toFixed(8));
};
